import { render, staticRenderFns } from "./CheckObjectDrawer.vue?vue&type=template&id=38761700&scoped=true&"
import script from "./CheckObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./CheckObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CheckObjectDrawer.vue?vue&type=style&index=0&id=38761700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38761700",
  null
  
)

export default component.exports